











import { Component, Prop, Vue } from 'vue-property-decorator';
import TrModal from '@/components/shared/TrModal.vue';
import {btnClasses} from '@/utils/btnClasses';

@Component({
  components: {
    TrModal,
  },
})
export default class cartLimitReachedModal extends Vue {
  btnClasses = btnClasses;

  @Prop({ default: false }) private showModal!: boolean;

  public openSampleBasketModal() {
    this.$emit('close');
    this.$store.dispatch('ordering/setSampleBasketOrderModalOpen', true);
  }

  close() {
    this.$emit('close');
  }
}
